import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { RecipesRoot, Spacer } from './Recipes.styles'
import { RecipeHero } from './components/RecipeHero'
import { SixRecipes } from './components/SixRecipes/SixRecipes'
import { Timeline } from './components/Timeline'
import { Benefits } from './components/Benefits'
import { Compare } from './components/Compare'
import { Reviews } from './components/Reviews'
import { Statistics } from './components/Statistics'
import { RecipeFooter } from './components/RecipeFooter'
import { Footer } from 'components/Footer'
import { ProductPageReviews } from 'fixtures/review'

type RecipesOwnProps = ComponentProps<typeof RecipesRoot>
export type RecipesProps = RecipesOwnProps & {}

export const Recipes = (_props: RecipesProps) => {
  const { t } = useTranslation()
  const header = <Header />
  const { melissa, mariah, sunny } = ProductPageReviews

  return (
    <RecipesRoot>
      <Layout hideCTA header={header}>
        <RecipeHero ctaLink='/meal-plan' ctaText={t('recipes:overview.cta-1')} background="tertiary-200"/> 
        <SixRecipes />
        <Timeline banner />
        <Benefits />
        <Compare />
        <Spacer />
        <Reviews cardColor="tertiary-200" background="accent-white" reviews={[melissa, mariah, sunny]}/> 
        <Statistics />
        <RecipeFooter ctaLink="https://wefeedraw.gorgias.help/en-US" cta={t('recipes:overview.cta-4')} header={t('recipes:overview.contact')} bg="tertiary-200" />
        <Footer />
      </Layout>
    </RecipesRoot>
  )
}

Recipes.displayName = 'Recipes'
